import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

/**
 * MobileStickyCta — Conversion booster for mobile only.
 * Appears after the user scrolls past the hero on screens < md.
 */
export const MobileStickyCta = () => {
    const navigate = useNavigate();
    const { t } = useLang();
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 520);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div
            data-testid="mobile-sticky-cta"
            className={`md:hidden fixed bottom-0 inset-x-0 z-40 px-4 pb-3 pt-3 transition-all duration-300 ${
                visible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
            }`}
        >
            <div className="bg-white/95 backdrop-blur-md rounded-2xl shadow-[0_-8px_30px_rgba(76,29,149,0.18)] border border-[#C9A55B]/30 px-4 py-3 flex items-center gap-3">
                <div className="flex-1 min-w-0">
                    <p className="text-[12px] font-semibold text-[#4C1D95] leading-tight">{t("mscTitle")}</p>
                    <p className="text-[11px] text-[#4B5563] inline-flex items-center gap-1 mt-0.5">
                        <ShieldCheck className="h-3 w-3 text-[#C9A55B]" /> {t("mscDpdp")}
                    </p>
                </div>
                <button
                    type="button"
                    onClick={() => navigate("/signup")}
                    data-testid="mobile-sticky-cta-start"
                    className="inline-flex items-center gap-1.5 bg-[#DC2626] hover:bg-[#EF4444] text-white rounded-full px-4 py-2.5 text-[13px] font-semibold transition-colors"
                >
                    {t("mscStart")} <ArrowRight className="h-4 w-4" />
                </button>
            </div>
        </div>
    );
};
